import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { RECAPTCHA_SKIP_SERVER_VERIFY } from '../config/recaptcha';

/**
 * Valida o token reCAPTCHA no servidor (Cloud Function verifyRecaptcha).
 * Em dev, defina REACT_APP_RECAPTCHA_SKIP_SERVER_VERIFY=true para pular a chamada HTTP.
 */
export async function verifyRecaptchaToken(token) {
  if (!token || typeof token !== 'string') {
    throw new Error('Confirme que você não é um robô.');
  }
  if (RECAPTCHA_SKIP_SERVER_VERIFY) {
    return;
  }
  try {
    const verify = httpsCallable(functions, 'verifyRecaptcha');
    await verify({ token });
  } catch (e) {
    const msg =
      e?.message ||
      (typeof e?.details === 'string' ? e.details : null) ||
      'Não foi possível validar o reCAPTCHA. Tente novamente.';
    throw new Error(msg);
  }
}
